/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2020 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import StringBuilder from "./StringBuilder";

export default class UriBuilder
{
    private _base: { toString(): string };
    private _params: Object[] = [];

    constructor(base: string = null)
    {
        this._base = base;
    }

    public AddParams(...params: Object[]): this
    {
        params.forEach(param => this.addParam(param));
        return this;
    }

    private addParam(params: Object): this
    {
        if (params == null) { return; }
        this._params.push(params);
        return this;
    }

    public toString(overrideValues: boolean = false): string
    {
        const sb: StringBuilder = new StringBuilder(this._base);

        if (overrideValues)
        {
            const params: Object = this._params[0];

            for (let i: number = 1; i < this._params.length; i++)
            {
                Object.assign(params, this._params[i]);
            }

            this.appendObject(sb, params);
        }
        else
        {
            this._params.forEach(p => this.appendObject(sb, p));
        }

        return sb.toString();
    }

    private appendObject(sb: StringBuilder, obj: Object): void
    {
        Object.keys(obj).forEach((key, i) =>
        {
            sb.append(i < 1 ? '?' : '&');
            sb.append(key);
            sb.append('=');
            sb.append(obj[key]);
        });
    }
}
